const KEY = "cannac.curriculum.progress.v1";

export type ProgressState = {
  completed: string[];
  lastLesson?: string;
  lastPath?: string;
};

function read(): ProgressState {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { completed: [] };
    const data = JSON.parse(raw) as ProgressState;
    return {
      completed: Array.isArray(data.completed) ? data.completed : [],
      lastLesson: data.lastLesson,
      lastPath: data.lastPath,
    };
  } catch {
    return { completed: [] };
  }
}

function write(state: ProgressState) {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    /* ignore quota */
  }
}

export function getProgress(): ProgressState {
  return read();
}

export function isLessonComplete(slug: string): boolean {
  return read().completed.includes(slug);
}

export function markLessonComplete(slug: string) {
  const state = read();
  if (!state.completed.includes(slug)) state.completed.push(slug);
  state.lastLesson = slug;
  write(state);
}

export function setLastLesson(slug: string) {
  const state = read();
  state.lastLesson = slug;
  write(state);
}

export function setLastPath(pathId: string) {
  const state = read();
  state.lastPath = pathId;
  write(state);
}

export function pathProgress(slugs: string[]): { done: number; total: number } {
  const completed = new Set(read().completed);
  const done = slugs.filter((s) => completed.has(s)).length;
  return { done, total: slugs.length };
}
